module.exports = __webpack_public_path__ + "static/media/coursera_logo.646f855e.svg";